export const ActivitiesActionTypes = {
  API_RESPONSE_SUCCESS: '@@activities/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@activities/API_RESPONSE_ERROR',

  GET_ACTIVITY: '@@activities/GET_ACTIVITY',
  LIST_ACTIVITIES: '@@activities/LIST_ACTIVITIES',
  ADD_ACTIVITY: '@@activities/ADD_ACTIVITY',
  UPDATE_ACTIVITY: '@@activities/UPDATE_ACTIVITY',
  DELETE_ACTIVITY: '@@activities/DELETE_ACTIVITY',

  RESET: '@@activities/RESET'
}
